import * as React from "react";
import { forwardRef } from "react";
const SvgInformation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, viewBox: "0 0 17 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.491 15.666a7.688 7.688 0 1 1 0-15.375 7.688 7.688 0 0 1 0 15.375zm.945-2.762V5.85h-1.89v7.053h1.89zm-2-8.879c0 .287.096.522.29.704.193.183.448.274.765.274s.573-.091.766-.274a.925.925 0 0 0 .29-.704.922.922 0 0 0-.287-.697c-.19-.183-.447-.274-.769-.274-.326 0-.583.091-.772.274a.928.928 0 0 0-.284.697z" }));
const ForwardRef = forwardRef(SvgInformation);
export default ForwardRef;
